import { createSelector } from 'reselect';
export const imageLoadingSelector = state => state.imageLoading;
export const isImagesInLoadingSelector = createSelector(imageLoadingSelector, imagesLoaded => !!imagesLoaded.loadingItems);